import { RoamSiniestrosParams } from '../../../services/roamApi';
import { FiltersState } from '../components/SiniestrosFilters/types';
import { SiniestroStatus } from '../types/siniestros.types';

export const TAB_STATUS_MAP: Record<SiniestroStatus, number[] | undefined> = {
    ALL: undefined,
    PENDING: [1],
    OPEN: [2],
    FINALIZED: [3],
    CANCELLED: [4]
};

interface BuildSiniestrosQueryParams {
    filters?: Record<string, any> | null;
    extraFilters?: FiltersState | null;
    idsEstado?: number[];
    idPreventor?: number;
    empleado?: string;
    nroRoam?: string | number;
}

// Parámetros de la grilla de siniestros. Los usan ROAM y la tab Siniestros de Gestión de
// Archivos SRT (SMP-561); cada pantalla decide estado y preventor
export const buildSiniestrosQueryParams = ({
    filters,
    extraFilters,
    idsEstado,
    idPreventor,
    empleado,
    nroRoam
}: BuildSiniestrosQueryParams): RoamSiniestrosParams => ({
    skip: filters?.skip ?? 0,
    take: filters?.take ?? 10,
    nroRoam: nroRoam && String(nroRoam).trim().length >= 4 ? String(nroRoam).trim() : undefined,
    idCliente: extraFilters?.clientId,
    empleado,
    idOrganismoCentral: extraFilters?.idOrganismoCentral || undefined,
    idOrganismo: extraFilters?.organismoId || undefined,
    idProvincia: extraFilters?.provinceId,
    idTipoSiniestro: extraFilters?.accidentType,
    // Regla de negocio (confirmada el 30-10-2026, SMP-637 / E1-109): con Tipo = Todos no se
    // muestran los In Itinere (tipo 3); se ven solo filtrando por ese tipo. Aplica también al
    // Excel de ROAM, que usa estos parámetros
    notIdTipoSiniestro: extraFilters?.accidentType ? undefined : 3,
    idsEstado: idsEstado ?? undefined,
    idPreventor: idPreventor || undefined,
    nombreEstablecimiento: extraFilters?.establishmentName || undefined,
    idEstadoSRT: extraFilters?.srtStatus || undefined,
    tieneVisitaInvestigacion:
        extraFilters?.investigation !== null && extraFilters?.investigation !== undefined
            ? extraFilters.investigation
            : undefined,
    anioSiniestro: extraFilters?.anioSiniestro || undefined,
    lugarOcurrencia: extraFilters?.lugarOcurrencia || undefined,
    orderby: filters?.ordenador ? (filters.ordenador as string).replace(':', '-') : undefined
});
